module.exports = __webpack_public_path__ + "static/img/baoJianQu.caf4847.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/baoJianQu.jpg
// module id = wUjq
// module chunks = 2